<template>
  <div class="p-4">
    <h4 class="text-w mb-3 text-gray">{{ header_table }}</h4>
    <!-- <pre>{{data}}</pre> -->
    <b-table-simple
      :style="{ 'overflow-y': 'auto', 'max-height': maxheight }"
      hover
      responsive="sm"
    >
      <b-thead class="table_header">
        <b-tr align="center" class="bgHeader">
          <b-th v-for="i in header.header" :key="i"
            >{{ i }} <span v-if="i == 'Power Consumption'">(kWh)</span>
            <span v-if="['Pond Water Level', 'Canal Water Level'].includes(i)"
              >(MSL)</span
            >
            <span v-if="['Rain Volume'].includes(i)"> (mm) </span>
            <span
              v-if="
                ['Water Pump 01', 'Water Pump 02', 'Water Pump 03'].includes(i)
              "
            >
              (m<sup>3</sup>/h)
            </span></b-th
          >
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="i in data" :key="i">
          <b-td v-for="j in header.keys" :key="j">
            <span v-if="[undefined, NaN, 'NaN'].includes(i[j])">0.00</span
            ><span v-else>{{ i[j] }} </span>
            <!-- <span v-if="j == 'power_consumption'">kWh</span>
            <span v-if="['Level_1S', 'Level_2S'].includes(j)"> MSL </span>
            <span v-if="['Rain'].includes(j)"> mm </span>
            <span v-if="['Hour_1_new', 'Hour_2_new', 'Hour_3_new'].includes(j)">
              Hour
            </span> -->
          </b-td>
          <!-- <b-td align="center">1.77 hr</b-td>
          <b-td align="center">{{ i.value }} kWh</b-td>
          <b-td align="center">{{ i.value }} kWh</b-td> -->
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  props: ["header", "header_table", "maxheight", "data"],
  data() {
    return {
      data: [
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
        { time: "2021-02-24 08:00:00", value: 25.35 },
        { time: "2021-02-24 08:00:00", value: 23.03 },
        { time: "2021-02-24 08:00:00", value: 31.0 },
      ],
    };
  },
};
</script>

<style scoped>
.text-gray {
  color: #707070;
  font-weight: 500;
}
.bgHeader {
  background: #32c040;
  color: #ffffff;
  /* font-size: 0.78rem; */
}
.table_waterpump {
  overflow-y: auto;
  max-height: 340px;
}
.table_header {
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>